import {
    NO_SUB_SEQUENCE,
} from 'session/constants.js';
import {
    setSelectedArrangementEvents,
    setArrangementPatternSelected
} from 'actions/index.js';
import {NUMBER_TO_RESOLUTION} from 'constants/resolution-keys.js';
import {
    editResolution,
    editPattern
} from 'session/operations/actions.js';

export function onKeyDown(event, sequencerEngine) {
    let key = event.key;
    if (key > 0 && key <= 9) {
        onNumberDown(parseInt(key), sequencerEngine);
    }
}

function onNumberDown(number, sequencerEngine) {
    if (sequencerEngine.rolling) {
        return;
    }

    if (isRollsRowSelected(sequencerEngine)) {
        let selectedRollEvents = getSelectedEvents(sequencerEngine, NO_SUB_SEQUENCE.id);
        for (let i in selectedRollEvents) {
            let event = selectedRollEvents[i];
            sequencerEngine.mix.dispatch(editResolution(event, NUMBER_TO_RESOLUTION[number]));
        }
        return;
    } 

    for (let i in sequencerEngine.subSequences) {
        let subSequence = sequencerEngine.subSequences[i];
        let selectedPatternSwitchEvents =
            getSelectedEvents(sequencerEngine, subSequence.id);

        for (let i in selectedPatternSwitchEvents) {
            let event = selectedPatternSwitchEvents[i];
            sequencerEngine.mix.dispatch(editPattern(event, number - 1));
            if (state(sequencerEngine).arrangement.patternSelected) {
                sequencerEngine.dispatch(setArrangementPatternSelected(event));
            }
            
        }
        sequencerEngine.dispatch(setSelectedArrangementEvents(
            {
                ... selectedPatternSwitchEvents
            }));
    }
}

function getSelectedEvents(sequencerEngine, subSequenceId) {
    return sequencerEngine.state.arrangement.selectedEvents || [];
}

export function getRowsSelected(sequencerEngine) {
    return sequencerEngine.state.arrangement.selectedRows;
}

function isRollsRowSelected(sequencerEngine) {
    return getRowsSelected(sequencerEngine).indexOf(NO_SUB_SEQUENCE.id) > -1;
}

const state = (engine) => engine.state;
